import React from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import { Provider } from 'react-redux';

import './assets/styles/app.less';
import PrivateRoute from './navigation/PrivateRoute';

import Login from './pages/Login';
import Payments from './pages/Payments';
import Users from './pages/Users'
import Dashboard from './pages/Dashboard'

import store from './store/store';

const App = () => {
  return (
    <>
      <Provider store={store}>
        <Router>
          <Switch>
            <Route exact path={'/login'} component={Login} />
            <PrivateRoute exact path={'/'} component={Dashboard} />
            <PrivateRoute exact path={'/users'} component={Users} />
            <PrivateRoute exact path={'/payments'} component={Payments} />
          </Switch>
        </Router>
      </Provider>
    </>
  );
};

export default App;
